import { TAG_COLORS, CATEGORY_LABELS } from '@/lib/constants';
import type { EventCategory } from '@/lib/types';
import { cn } from '@/lib/utils';

interface TagBadgeProps {
  category: EventCategory;
  className?: string;
}

export function TagBadge({ category, className }: TagBadgeProps) {
  const colors = TAG_COLORS[category];

  return (
    <span
      className={cn('inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium', className)}
      style={{
        background: colors.bg,
        color: colors.text,
        border: `1px solid ${colors.border}`,
      }}
    >
      {CATEGORY_LABELS[category]}
    </span>
  );
}
